<template>
	<div class="customer-container">
		<b-container fluid>
			<div class="main-content">
				<b-row>
					<b-col md="3" class="text-center">
						<div class="avatar">
							<Avatar :avatar="avatar"/>
						</div>
						<!--<div v-if="showPreCalculatedAmount" class="pre-calculated-amount">
							<div class="number">{{ preCalculatedAmount }}</div>
							<div class="subtitle">{{ preCalculatedAmount === 1 ? 'Job Match' : 'Job Matches' }}</div>
							<div class="info">Denk dran: Mehr Infos von dir = kleinere Zahl = <b>perfekter Match!</b>
							</div>
						</div>-->
					</b-col>
					<b-col md="5">
						<Step0
							v-if="step === 0"
							@continue="goToNextStep"
						/>
						<Step1
							v-if="step === 1"
							v-model="step1Data"
							:title="steps[step-1].text"
							@input="doPreAmountCalculation"
						/>
						<Step2
							v-if="step === 2"
							v-model="step2Data"
							:title="steps[step-1].text"
							@input="doPreAmountCalculation"
						/>
						<Step3
							v-if="step3Eligible && step === 3"
							v-model="step3Data"
							:title="steps[step-1].textProvider(textProviderData)"
							:career-level-eligible="careerLevelEligible"
							:organisational-area-eligible="organisationalAreaEligible"
							:functions="step1Data.functions"
						/>
						<Step4
							v-if="step === realStep4"
							v-model="step4Data"
							:title="steps[step-1].text"
						/>
						<Step5
							v-if="step === realStep5"
							v-model="step5Data"
							:title="steps[step-1].text"
						/>
						<Step6
							v-if="step === realStep6"
							:title="steps[step-1].text"
							:career-level-eligible="careerLevelEligible"
							:organisational-area-eligible="organisationalAreaEligible"
							:form-data="{
								step1: step1Data,
								step2: step2Data,
								step3: step3Data,
								step4: step4Data,
								step5: step5Data
							}"
						/>
					</b-col>
					<b-col md="4">
						<div class="right-area">
							<ul v-if="step > 1" class="steps">
								<li
									v-if="!loopStep.hideInNav"
									v-for="loopStep in steps"
									:key="loopStep.number"
									:class="{'step': true, 'active': step === loopStep.number, 'done': step > loopStep.number}"
								>
									<template v-if="step > loopStep.number && !isLastStep">
										<a href="#" class="step-link" @click.prevent="step = loopStep.number">
											<span class="step-number">
												<Icon icon="checkmark"/>
											</span>
											<span class="step-text">
												{{ getStepTitle(loopStep) }}
											</span>
										</a>
									</template>
									<template v-else>
										<span class="step-number">
											<Icon v-if="step > loopStep.number" icon="checkmark"/>
											<span v-else>{{ loopStep.number }}</span>
										</span>
										<span class="step-text">{{ getStepTitle(loopStep) }}</span>
									</template>
								</li>
							</ul>
						</div>
					</b-col>
				</b-row>
			</div>
			<div v-if="step > 0 && !isLastStep" class="continue">
				<a href="#" :class="['to-next-step', { 'disabled': !canContinue }]" @click.prevent="goToNextStep">
					Weiter
					<span class="to-next-step-icon">
						<Icon icon="caret-right"/>
					</span>
				</a>
				<span class="current-step">{{ step }}</span>
				<a
					v-for="(previousStep, i) in previousSteps"
					:key="'previous-step-' + previousStep"
					href="#"
					:class="'previous-step index-' + i"
					@click.prevent="goToStep(previousStep)"
				>
					{{ previousStep }}
				</a>
			</div>
		</b-container>
	</div>
</template>
<script>
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import Step5 from "./Step5";
import Step6 from "./Step6";
import Icon from "@/vue/icon/Icon"
import _ from "lodash";
import {mapState} from "vuex";
import {setHash} from "@/helper/Url";
import * as CareerLevel from "@/helper/characteristic/CareerLevel";
import * as OrganisationalArea from "@/helper/characteristic/OrganisationalArea";
import Avatar, {CAT_NOTEBOOK, HOLDING_EURO, IDEA_LIGHT_BULB, CLIPBOARD, WELCOME} from "@/vue/common/image/Avatar.vue";
import {scrollToTop} from "@/helper/Window";
import Step0 from "./Step0.vue";

const STEPS = [
	{
		number: 1,
		text: 'Welchen Job besetzt du?',
	},
	{
		number: 2,
		text: 'Welche Job-Art ist das?',
	},
	{
		number: 3,
		textProvider: ({careerLevelEligible}) =>
		{
			return careerLevelEligible
				? 'Welche Berufsebene ist das?'
				: 'Welche Branche habt ihr?';
		}
	},
	{
		number: 4,
		text: 'Wo ist der Arbeitsort für diesen Job?',
	},
	{
		number: 5,
		text: 'Los geht\'s!',
	},
	{
		number: 6,
		text: 'Yeah, geschafft!',
		hideInNav: true
	},
];

const AVATARS = {
	0: {
		name: CAT_NOTEBOOK
	},
	1: {
		name: HOLDING_EURO
	},
	2: {
		name: HOLDING_EURO
	},
	3: {
		name: IDEA_LIGHT_BULB
	},
	4: {
		name: IDEA_LIGHT_BULB
	},
	5: {
		name: CLIPBOARD
	},
	6: {
		name: WELCOME
	},
};

export default {

	components: {
		Step0,
		Avatar,
		Step1,
		Step2,
		Step3,
		Step4,
		Step5,
		Step6,
		Icon,
	},

	mounted ()
	{
		window.onhashchange = () =>
		{
			if (location.hash && location.hash.startsWith('#step-'))
			{
				const step = parseInt(location.hash.replace('#step-', ''));

				if (this.canGoToStep(step))
				{
					this.step = step;
				}
			}
			else
			{
				this.step = 1;
			}
		};
	},

	data ()
	{
		return {
			step: 1,
			step1Data: undefined,
			step2Data: undefined,
			step3Data: undefined,
			step4Data: undefined,
			step5Data: undefined,
			/*preCalculatedAmount: undefined,
			loadingPreCalculatedAmount: false,*/

		};
	},

	computed: {
		...mapState('meta', [
			'meta',
		]),
		textProviderData ()
		{
			return {
				careerLevelEligible: this.careerLevelEligible
			};
		},
		careerLevelEligible ()
		{
			if (!this.step2Data?.employmentModes)
			{
				return true;
			}

			return CareerLevel.isEligible(
				_.map(this.step2Data.employmentModes, 'item')
			);
		},
		organisationalAreaEligible ()
		{
			if (!this.step1Data?.functions)
			{
				return true;
			}

			return OrganisationalArea.isEligible(
				_.map(this.step1Data.functions, 'item')
			);
		},
		previousSteps ()
		{
			return _.reverse(
				_.range(1, this.step, 1)
			);
		},
		isLastStep ()
		{
			return this.step === this.steps.length;
		},
		realStep4 ()
		{
			return this.getRealStep(4);
		},
		realStep5 ()
		{
			return this.getRealStep(5);
		},
		realStep6 ()
		{
			return this.getRealStep(6);
		},
		avatar ()
		{
			return AVATARS[this.step].name;
		},
		preCalculateData ()
		{
			return undefined;

			// let preCalculatedData = {};
			//
			// let hasData = false;
			//
			// // TODO adapt to new structure when it shall be enabled (endpoint in backend must be adapted as well)
			//
			// if (this.step1Data && this.step1Data.functions && isDefined(this.step1Data.functions))
			// {
			// 	preCalculatedData.functions = prepareCharacteristic(this.step1Data.functions);
			// 	hasData = true;
			// }
			//
			// if (this.step1Data && this.step1Data.employmentModes && isDefined(this.step1Data.employmentModes))
			// {
			// 	preCalculatedData.employmentModes = prepareCharacteristic(this.step1Data.employmentModes);
			// 	hasData = true;
			// }
			//
			// if (this.step2Data && this.step2Data.geo && isDefined(this.step2Data.geo))
			// {
			// 	preCalculatedData.placeOfWork = prepareCharacteristic(this.step2Data.geo);
			// 	hasData = true;
			// }
			//
			// if (this.step2Data && this.step2Data.careerLevels && isDefined(this.step2Data.careerLevels))
			// {
			// 	preCalculatedData.careerLevels = prepareCharacteristic(this.step2Data.careerLevels);
			// 	hasData = true;
			// }
			//
			// if (this.step2Data && this.step2Data.industrialSectors && isDefined(this.step2Data.industrialSectors))
			// {
			// 	preCalculatedData.industrialSectors = prepareCharacteristic(this.step2Data.industrialSectors);
			// 	hasData = true;
			// }
			//
			// return hasData ? preCalculatedData : undefined;
		},
		step3Eligible ()
		{
			return this.careerLevelEligible || this.organisationalAreaEligible;
		},
		// showPreCalculatedAmount ()
		// {
		// 	return isDefined(this.preCalculateData) && this.preCalculatedAmount > 0;
		// },
		steps ()
		{
			let steps = [];

			let number = 1;
			STEPS.forEach(step =>
			{
				if (step.number === 3 && !this.step3Eligible)
				{
					return true; // continue
				}

				steps.push({
					...step,
					number: number++
				})
			});

			return steps;
		},
		canContinue ()
		{
			return this.canGoToStep(this.step + 1);
		},
	},

	methods: {
		getRealStep (step)
		{
			if (!this.step3Eligible)
			{
				step--;
			}

			return step;
		},
		getStepTitle (step)
		{
			return step.textProvider ? step.textProvider(this.textProviderData) : step.text;
		},
		canGoToStep (step)
		{
			if (step === 1)
			{
				return true;
			}

			let allEligibleDataSets = {
				0: this.step1Data,
				1: this.step2Data,
				2: this.step3Data,
				3: this.step4Data,
				4: this.step5Data
			};

			if (!this.step3Eligible)
			{
				delete allEligibleDataSets[2];
			}

			allEligibleDataSets = _.values(allEligibleDataSets);

			let toCheck = [];

			for (let i = 1; i < step; i++)
			{
				toCheck.push(allEligibleDataSets[i - 1]);
			}

			if (toCheck.length === 0)
			{
				return false;
			}

			return toCheck.length === _.filter(toCheck, data => data && data.valid).length;
		},
		goToNextStep ()
		{
			if (!this.canContinue)
			{
				return;
			}

			this.goToStep(this.step + 1);
		},
		goToStep (step)
		{
			this.step = step;

			setHash('step-' + step);

			this.$nextTick(() =>
			{
				scrollToTop();
			});
		},
		async doPreAmountCalculation ()
		{
			// TODO deactivated for now
			// if (!this.preCalculateData || this.loadingPreCalculatedAmount)
			// {
			// 	return;
			// }
			//
			// this.loadingPreCalculatedAmount = true;
			//
			// const response = await new Hits()
			// 	.setData(this.preCalculateData)
			// 	.call();
			//
			// this.preCalculatedAmount = response.data.amount;
			//
			// this.loadingPreCalculatedAmount = false;
		}
	},
}
</script>
